import React from "react";

import nary from "@/modules/nary";
import thousandsFormat from "@/modules/thousandsFormat";
import { isPortrait } from "@/modules/commonMobile";
import { assetImg } from "@/modules/moduleImporter";

import img_cross from "../../../assets/img/img_cross.png";

import "../m29/index.scss";
import { IMachineGameResultHistoryProps } from "@/types/GameHistoryTypes";

//Based on Shio Balls
// 5D
export default class M30 extends React.Component<IMachineGameResultHistoryProps> {
	render() {
		// console.log("props on m30", this.props);

		const reversedHistory = this.props.history.slice(0).reverse();
		const viewedHistoryCount = (this.props.mobile && isPortrait()) ? 6 : 3;

		const langdata = this.props.langdata;

		const tickets = this.props.tickets;
		const hasTickets = tickets && tickets.length > 0;

		// console.log("m30 tickets", tickets);

		return (this.props.type !== "ticket") ? (
			//History
			<div className="history-container m30-history">
				{
					reversedHistory.slice(0, viewedHistoryCount).map(
						(historyItem, rowIdx) => {
							//Process history details here
							const splitNumbers = historyItem.angka.split(",").map(item => Number(item));

							//Copied from PopupResultHistory
							let odds = 0, evens = 0,
								highs = 0, lows = 0;
							splitNumbers.forEach(num => {
								if (num % 2) odds++;
								else evens++;

								if (num >= 5) highs++;
								else lows++;
							});

							return (
								<div className="row" key={"GRH_m30_" + rowIdx}>
									<div>
										{
											historyItem.angka.split(",").map((item, idx) =>
												assetImg("m30", item + "", "GRH_m30_" + rowIdx + "_" + idx)
											)
										}
									</div>

									{
										this.props.lobbyDesktop ? null :
											(
												<div className="fifty-fifty">
													{/* Copied from PopupResultHistory */}
													{
														//Todo: use translations
													}
													<div className="sl-green-new">
														{splitNumbers.reduce((a, b) => a + b) >= 23 ? langdata["txt_big"] : langdata["txt_small"]}
													</div>
													<div className="sl-cyan-new">
														{splitNumbers.reduce((a, b) => a + b) % 2 ? langdata["txt_odd"] : langdata["txt_even"]}
													</div>

													<div className="sl-green-new">
														{highs === 5 ? "all high" : lows === 5 ? langdata["txt_all_low"] : "-"}
													</div>
													<div className="sl-cyan-new">
														{odds === 5 ? "all odd" : evens === 5 ? langdata["txt_all_even"] : "-"}
													</div>
												</div>
											)
									}
								</div>
							);
						}
					)
				}
			</div>
		) : ( 
				//Running Tickets
				<div className={"m30-ticket" + (this.props.mustSubmitTickets ? " must-submit" : "")}
					body-scroll-lock-ignore="true">
					{
						hasTickets ?
							tickets.map((ticketItem, rowIdx) => {
								const ary = ticketItem.tebak.split(",");

								const is5050 = ticketItem.type === "n50";

								//How to align right arrays:
								let splitTebak = ["", "", "", "", ...ary.filter(item => item !== "")];
								splitTebak = splitTebak.slice(splitTebak.length - 5, splitTebak.length);

								return (
									<div className="row" key={"GRH_m30_ticket_" + rowIdx}>
										<div className="top">
											<div className="ticket-number">
												{rowIdx + 1}
											</div>

											<div className="ticket-type">
												{
													//50-50 Special
													is5050 ? "50-50" :

														//Colok or D
														(ticketItem.type[0] === "c" ? "Colok " : "") +
														ticketItem.type[1] + "D"
												}
											</div>

											<div className={"animals" + (is5050 ? " fifty-fifty" : "")}>
												{
													is5050 ? (
														<div>
															{langdata["txt_" + ticketItem.tebak.replace("-", "_").replace(/,/g, "")]}
														</div>
													) : (
															//Shows numbers
															nary(5).map((_item, idx) => {
																const splitItem = splitTebak[idx];
																const key = "GRH_m30_ticket_" + rowIdx + "_" + idx;

																return splitItem ?
																	assetImg("m30",
																		splitItem + "",
																		key) :
																	<div className="empty"
																		key={key}>
																		{"\u00a0"}
																	</div>;
															})
														)
												}
											</div>

											{
												//After Rebet, shows a big cross emoji
												this.props.mustSubmitTickets &&
													<img className="remove-ticket"
														src={img_cross}
														alt="Remove ticket"

														{...{
															index: rowIdx,
															pcode: this.props.pcode
														}}

														onClick={this.props.removeTicket} />
											}
										</div>

										<div className="bottom">
											<div>BET: {thousandsFormat(ticketItem.taruhan, langdata.language_code)}</div>
											<div>PERIODE: {ticketItem.periode}</div>
										</div>
									</div>
								);
							}) : <div className="no-tickets">
								{langdata["txt_no_tickets"]}
							</div>
					}
				</div>
			);
	}
}